import { useSrpContext } from '@/src/contexts'
import { useTranslations } from 'next-intl'

import PlacesToVisit from './placesToVisit'

const PlacesToVisitWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')

    const topPlaces = sections?.destinationTeaser?.topPlaces ?? sections?.destination?.placesToVisit ?? []
    const cityName = sections?.destinationTeaser?.destinationName
        ?? sections?.destination?.info?.title
        ?? ''

    if (!topPlaces.length) return null

    const teaserPlaces = topPlaces.slice(0, 3)
    const heading = cityName ? t('placesToVisitIn', { city: cityName }) : ''

    return <PlacesToVisit heading={heading} places={teaserPlaces} />
}

export default PlacesToVisitWrapper
